<template>
  <div class="bkw-dialog quizzes-wrapper"
              :class="{ 'bkw-dialog__exam' : isExam && !isSceneExamList }"
              ref="dialog"
              :data-exercise-id="currentExercise.id"
              :data-exercise-count="newQuizzes.length"
              :is-disable-close="true"
              :is-show-footer="false">
    <template slot="title">
      <van-quizzes-toolbar :title="navigation" :is-forced="false" @close="close" />
    </template>
    <div class="bkw-dialog-wrap" ref="wrap">
      <div class="ready" v-if="isSceneReady">
        <h2>{{title}}</h2>
        <h2>{{subtitle}}</h2>
        <p v-if="description">{{ description }}</p>
        <br />
        <div class="button-wrapper" v-if="quizzes.length">
          <el-button class="btn btn-orange-square" @click="startLearn">
            {{type == 'test'? '开始测试' : '开始学习'}}
          </el-button>
        </div>
      </div>
      <template v-show="isScenePlaying">
        <div class="time" v-if="isExam && !isSceneError&& !isSceneReady && !isSceneExamList">
          {{secondsToTime}}
        </div>
        <!-- <p class="tip-line">{{ description }}</p> -->
        <van-quizzes-controller
            v-if="isScenePlaying"
            ref="controller"
            :is-exam="isExam"
            :exercises="newQuizzes"
            :user-answer="userAnswer"
            :play-times="playTimes"
            :project-code="projectCode"
            :type="type"
            :status="status"
            @change="handleChange"
            @result="handleResult"
            @finish="handleFinished"
            @exerciseChange="exerciseChange"
        />
      </template>
      <div class="ready" v-if="isSceneError">
        <h2>{{errMsg || '哎呦~好像网络出了问题，请点击下面的重试按钮。'}}</h2>
        <br />
        <div>
          <el-button type="primary" size="small" round v-if="!errCode" @click="retry">
            重试
          </el-button>
        </div>
      </div>
      <div class="rest" v-if="isRest">
        <h2>{{ info.message }}</h2>
        <div class="info">
          <h3>完成情况</h3>
          <div>当前已练小题: <span class="active">{{ info.wordCount }}</span> 个</div>
          <div>游戏用时: <span class="active">{{ info.time }}</span></div>
          <div>大题正答率: <span class="active">{{ info.score }}%</span></div>
        </div>
        <el-button class="btn btn-orange-square" @click="nextStep">
          {{ isContinue? '继续学习' : '完成' }}
        </el-button>
      </div>
      <div class="result" v-if="isHalftime">
        <h2>你真棒！完成一半的错题啦！</h2>
        <h3>当前已练错题: {{ result.length }}个</h3>
        <div>当前仅剩下{{ quizzes.length - result.length }}个错题了，继续练习即可结束本日错题巩固环节；也可以休息片刻，去学习新的内容。</div>
        <div>
          <el-button type="primary" size="small" @click="continueWrongQuizzes">继续练习</el-button>
          <el-button type="danger" size="small" @click="handleFinished">休息片刻</el-button>
        </div>
      </div>
      <div class="result" v-if="isFreeTime">
        <h2>太棒了！今日错题已全部完成！</h2>
        <h3>当前已练错题: {{ result.length }}个</h3>
        <div>你真棒！完成了今日的错题巩固环节，现在快去学习其他内容吧！</div>
        <div>
          <el-button
            class="btn btn-orange-square"
            @click="handleFinished">前往学习</el-button>
        </div>
      </div>
      <van-exam-list
        v-if="isSceneExamList"
        :results="filterResult.length ? filterResult : results"
        :project-code="projectCode"
        ref="examList"/>
    </div>
    <van-answer-card
      v-if="isShowAnswerCard && !isSceneError"
      :is-exam="isSceneFinished"
      :show-detail="false"
      :show-tagline="false"
      :title="navigation"
      :score="score"
      :total="results.length"
      :results="results">
      <div class="detail" :class="{ 'exam-detail': isSceneFinished }" slot="detail">
        <div class="item" v-for="(item, index) in answerCardData" :key="index">
          <div class="tag">
            <el-tag plain size="small">
              {{quizName[item.code] && quizName[item.code][item.mode]}}
            </el-tag>
          </div>
          <span class="number"
                :class="{
                  filled: results[answer.index].isComplete,
                  success: results[answer.index].isRight && isSceneFinished,
                  danger: !results[answer.index].isRight && isSceneFinished,
                }"
                @click="selectExercise(answer.index)"
                v-for="(answer, number) in item.quizzes"
                :index="number"
                :global-index="getGlobalQuizIndex(index, number)"
                :key="answer.index">{{number + 1}}</span>
        </div>
      </div>
    </van-answer-card>
    <van-footer-bar
      class="exam-control"
      v-if="isExam && !isSceneReady"
      :is-exam="isExam"
      :is-exam-records="isExamRecords"
      :is-show-bottom-control="true"
      :is-show-tip="false"
      :is-disabled-replay="isDisabledReplay"
      :is-show-answer-card="isShowAnswerCard"
      :total="results.length"
      :finished-text="finishedText"
      :current="exerciseIndex"
      :is-show-replay="score < 100 && isShowReplay"
      :currentExercise="currentExercise"
      :is-show-speaker="
        !!(currentExercise.code !== 'DCPX'
        && currentExercise.code !== 'THXZ'
        && !isSelectWord
        && currentExercise.code !== 'DCTX' && currentExercise.audio)"
      :is-show-eraser="!!(currentExercise.code === 'HYDC' || currentExercise.code === 'JXZH')"
      :scene="scene"
      :results="results"
      @replay="replay"
      @speak="speak"
      @finished="finishedExam"
      @submit="handleSubmitExamBtn"
      @back="backFinishedScene"
      @detail="detail"
      @clear="clear"
      @prev="prev"
      @next="next"
      @toggleCheckType="handlerFilterResult">
      <div
        class="footer-button-wrapper"
        slot="foot">
        <el-button
          class="btn btn-orange-square"
          v-if="isShowCertificate"
          @click="openCertificate">
          查看证书
        </el-button>
      </div>
    </van-footer-bar>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  RadioGroup,
  RadioButton,
  Button,
  Tag,
} from 'element-ui';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import VanExamList from '@/components/quizzes/chinese/ExamDetail.vue';
import VanQuizzesController from '@/components/quizzes/chinese/Quizzes.vue';
import VanFooterBar from '@/components/common/FooterBar.vue';
import VanAnswerCard from '@/components/common/AnswerCard.vue';
import utils from '@/services/utils';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  examList: 4,
  error: 5,
  empty: 6,
  rest: 7, // 结算页面
  halftime: 8, // 中场休息
  freeTime: 9, // 自由时间
});

export default {
  components: {
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    VanQuizzesToolbar,
    VanQuizzesController,
    VanFooterBar,
    VanAnswerCard,
    ElButton: Button,
    ElTag: Tag,
    VanExamList,
  },
  props: {
    navigation: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
    },
    learnMode: {
      type: String,
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    quizzes: {
      type: Array,
      default: () => ([]),
    },
    playTimes: {
      type: Number,
      default: 1,
    },
    status: {
      type: Number,
      default: 0,
    },
    projectCode: {
      type: String,
      default: '',
    },
    isExamRecords: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quizName: {
        CHXZ: {
          1: '词汇选择（选解释）',
          2: '词汇选择（选单词）',
          3: '听音选词',
          4: '听音选义',
        },
        DX: {
          0: '单项选择',
        },
        HYDC: {
          0: '还原单词',
        },
        DCTX: {
          0: '单词听写',
        },
        SK: {
          1: '闪卡练习（学习模式）',
          2: '闪卡练习（抄写模式）',
          3: '闪卡练习（录音模式）',
        },
        HYDX: {
          0: '还原单词',
        },
        DCPX: {
          1: '单词拼写（随机模式）',
          2: '单词拼写（默写模式）',
          3: '单词拼写（自定义模式）',
        },
        TYLJ: {
          0: '听音连句',
        },
        BQWZ: {
          0: '补全文章',
        },
        JXZH: {
          0: '句型转换',
        },
        QHLJ: {
          1: '强化炼句（简单模式）',
          2: '强化炼句（复杂模式）',
          3: '强化炼句（默写模式）',
          4: '强化炼句（自定义模式）',
        },
        YDLJ: {
          0: '阅读理解',
        },
        XCTK: {
          0: '选词填空',
        },
        THXZ: {
          0: '听后选择',
        },
        WXTK: {
          0: '完形填空',
        },
        TK: {
          1: '填空',
        },
        WK: {
          0: '微课',
        },
      },
      scene: SCENE.ready,
      result: [],
      seconds: 0,
      mode: '', // replay 错题再练
      newQuizzes: [],
      results: [],
      answerCardData: [],
      score: 0,
      currentExercise: {},
      exerciseIndex: 0,
      repeatTimes: 0, // 口语重做次数
      errMsg: '',
      errCode: 0,
      isContinue: false, // 是否继续人机对话 (当人机对话出现多个)
      isShowAnswerCard: false,
      info: {}, // 完成情况
      remainQuizzes: [], // 剩余小题数
      isHalftimeed: false,
      filterResult: [],
    };
  },
  computed: {
    isExam() {
      return this.type === 'test' || this.type === 'drill';
    },
    secondsToTime() {
      return utils.secondsToTime(this.seconds);
    },
    isSelectWord() {
      return this.currentExercise.code === 'CHXZ' && this.currentExercise.mode === 2;
    },
    isSceneReady() {
      return this.scene === SCENE.ready;
    },
    isSceneExamList() {
      return this.scene === SCENE.examList;
    },
    isSceneFinished() {
      return this.scene === SCENE.finished;
    },
    isRest() {
      return this.scene === SCENE.rest;
    },
    isSceneError() {
      return this.scene === SCENE.error;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    isHalftime() {
      return this.scene === SCENE.halftime;
    },
    isFreeTime() {
      return this.scene === SCENE.freeTime;
    },
    isDisabledReplay() {
      return this.score === 100 || this.type === 'drill';
    },
    finishedText() {
      return this.isContinue === false ? '完成' : '下一步';
    },
    userAnswer() {
      if (this.results[this.exerciseIndex] && this.isExam) {
        return this.results[this.exerciseIndex].userAnswer || null;
      }
      return null;
    },
    isShowCertificate() {
      return this.type === 'drill' && this.score >= 100;
    },
    isShowReplay() {
      return this.type !== 'drill';
    },
  },
  watch: {
    quizzes() {
      this.reset();
      this.newQuizzes = utils.clone(this.quizzes);
      this.results = this.quizzes.map((item, index) => ({
        ...item,
        index,
        errorCount: 0,
        isRight: false,
        userAnswer: item.userAnswer ? JSON.parse(item.userAnswer) : null,
        isComplete: false,
      }));
      if (this.isExamRecords) {
        this.scene = SCENE.examList;
      } else {
        this.handleAnswerCardData();
      }
    },
    result() {
      if (Math.round(this.quizzes.length / 2) === this.remainQuizzes.length
        && (this.type === 'wrong' || this.type === 'force')
        && this.quizzes.length
        && this.quizzes.length >= 20
        && !this.isHalftimeed) {
        this.scene = SCENE.halftime;
        this.mode = 'half';
        this.isHalftimeed = true;
      } else if (this.quizzes.length === this.result.length
        && (this.type === 'wrong' || this.type === 'force')
        && this.quizzes.length
        && !this.remainQuizzes.length) {
        this.scene = SCENE.freeTime;
        this.mode = 'all';
        this.submit();
      }
    },
    currentExercise() {
      const isOutputAnswer = utils.storage('frontend_nb');
      if (isOutputAnswer) {
        this.outputAnswer();
      }
    },
    scene() {
      // 转场开始计时，试卷除外
      if (this.isScenePlaying) {
        this.startTimer();
      }
    },
  },
  methods: {
    handleResult({ results, remainQuizzes }) {
      this.remainQuizzes = remainQuizzes;
      results.forEach((result) => {
        utils.Array.pushReplace(this.result, result, 'id');
      });
    },
    startLearn() {
      this.scene = SCENE.playing;
    },
    startTimer() {
      if (this.timer) {
        this.stopTimer();
      }
      this.timer = setInterval(() => {
        this.seconds += 1;
      }, 1000);
    },
    stopTimer() {
      let val = 0;
      if (this.timer) {
        clearInterval(this.timer);
        val = this.seconds;
        this.timer = 0;
        this.seconds = 0;
      }
      return val;
    },
    continueWrongQuizzes() {
      this.newQuizzes = utils.clone(this.remainQuizzes);
      this.scene = SCENE.playing;
    },
    exerciseChange({ id, exerciseIndex = 0 }) {
      this.currentExercise = utils.Array.find(this.newQuizzes, { id }, 'id') || {};
      this.exerciseIndex = exerciseIndex;
    },
    handleAnswerCardData() {
      this.answerCardData = [];
      let quiz = this.results[0];
      let site = 0;
      if (quiz) {
        this.answerCardData[site] = {
          code: quiz.code,
          mode: quiz.mode,
          quizzes: [quiz],
        };
      }
      this.results.forEach((item, index) => {
        if (index > 0) {
          if (item.code === quiz.code && item.mode === quiz.mode) {
            this.answerCardData[site].quizzes.push(item);
          } else {
            site += 1;
            quiz = item;
            this.answerCardData[site] = {
              code: item.code,
              mode: item.mode,
              quizzes: [item],
            };
          }
        }
      });
    },
    handleChange(payload) {
      this.results.forEach((item) => {
        if (item.id === payload.id && item.code === payload.code && item.mode === payload.mode) {
          item.isRight = payload.isRight;
          item.isComplete = payload.isComplete;
          item.errorCount = payload.errorCount;
          item.userAnswer = utils.clone(payload.userAnswer);
        }
      });
    },
    backFinishedScene() {
      if (this.isExamRecords) {
        this.$emit('close');
        return;
      }
      this.scene = SCENE.finished;
      this.isShowAnswerCard = true;
    },
    handleFinished() {
      if (!this.isFreeTime) {
        this.submit({
          callback: () => {
            this.reset();
            if (this.type === 'view') {
              this.scene = SCENE.rest;
              this.$emit('refresh');
            } else if ((this.type === 'wrong'
              || this.type === 'force'
              || this.type === 'active_review')
              && this.quizzes.length) {
              this.close();
            } else {
              this.close();
            }
          },
        });
      } else {
        this.close();
      }
    },
    submit({ callback } = {}) {
      this.retry = () => {
        this.submit(callback);
      };

      const seconds = this.stopTimer();
      const data = this.result.map(result => ({
        id: result.id,
        parentId: result.parentId,
        code: result.code,
        errorCount: result.errorCount,
        status: result.errorCount ? 0 : 1,
        isRight: utils.isUndefined(result.isRight) ? true : result.isRight,
        answer: utils.isNumber(result.score) ? result.score : result.score || '',
      }));
      /* eslint-disable */
      this.$emit('submit', {
        data,
        seconds,
        type: this.type,
        mode: this.type,
        callback: ({ isContinue, ...info }) => {
          this.isContinue = isContinue;
          this.info = info;
          callback && callback();
        },
      });
    },
    submitExam() {
      const seconds = this.stopTimer();

      const data = this.results.map(result => ({
        id: result.id,
        parentId: result.parentId,
        code: result.code,
        status: result.isRight ? 1 : 0,
        errorCount: result.isRight ? 0 : 1,
        answer: result.userAnswer ? utils.toJson(result.userAnswer) : '',
      }));

      const emitted = (isRetry) => {
        this.$emit('submit', {
          data,
          seconds,
          type: this.learnMode === 'fallible' ? 'fallible' : this.type,
          mode: this.mode,
          callback: ({ score, isContinue }) => {
            this.isContinue = isContinue;
            if (score) {
              this.score = score;
            }
            if (isRetry) {
              this.scene = SCENE.finished;
            }
          },
        });
      };

      this.retry = () => {
        emitted(true);
      };

      emitted();
    },
    nextStep() {
      if (this.isContinue) {
        this.$emit('continue');
      } else {
        this.close();
      }
    },
    open() {
      this.$refs.dialog.open();
      this.$nextTick(() => {
        this.bindEnterEvent();
      });
    },
    close() {
      if (this.isHalftime) {
        this.submit({
          callback: () => {
            this.scene = SCENE.empty;
            this.isShowAnswerCard = false;
            this.currentExercise = {};
            this.unBindEnterEvent();
            this.$emit('close');
          },
        });
      } else {
        this.scene = SCENE.empty;
        this.isShowAnswerCard = false;
        this.currentExercise = {};
        this.unBindEnterEvent();
        this.$emit('close');
      }
    },
    replay() {
      this.newQuizzes = this.results.filter((item) => {
        return !item.isRight;
      });
      this.newQuizzes.forEach((item, index) => {
        item.isRight = false;
        item.userAnswer = null;
        item.isComplete = false;
        item.index = index;
       });
      this.results = utils.clone(this.newQuizzes);
      this.handleAnswerCardData();
      this.isShowAnswerCard = false;
      this.exerciseIndex = 0;
      this.mode = 'replay';
      this.startLearn();
    },
    finishedExam() {
      this.isShowAnswerCard = false;
      if (this.isContinue) {
        this.$emit('continue', this.learnMode);
      } else {
        this.close();
      }
    },
    reset({ scene = SCENE.ready, isResetAll = true } = {}) {
      this.scene = scene;
      this.result = [];
      this.exerciseIndex = 0;
      this.mode = '';
      this.remainQuizzes = [];
      this.isHalftimeed = false;
      if (isResetAll) {
        this.repeatTimes = 0;
      }
    },
    error({ code, message } = {}) {
      this.scene = SCENE.error;

      if (code) {
        this.errMsg = message;
        this.errCode = code;
      } else {
        this.errMsg = '';
        this.errCode = 0;
      }
    },
    outputAnswer() {
      const {
        code,
        answer,
        text,
        answerIndex,
        options,
        parts,
        items,
      } = this.currentExercise;
      let output;
      switch (code) {
        case 'TK':
          output = text;
          break;
        case 'JXZH':
          output = answer;
          break;
        case 'TYLJ':
        case 'QHLJ':
          output = text;
          break;
        case 'DX':
          output = options[answerIndex];
          break;
        case 'BQWZ':
          output = parts.map(part => `${part.answer}`).join('\n');
          break;
        case 'YDLJ':
        case 'XCTK':
        case 'THXZ':
        case 'WXTK':
          output = items.map(item => `${item.answer}`).join('\n');
          break;
        default:
          break;
      }
      if (output) {
        const style = 'background: green; color:#fff;';
        console.log('%c answer =>', style, output);
      }
    },
    getGlobalQuizIndex(index, offset) {
      return this.answerCardData
        .slice(0, index)
        .reduce((pre, cur) => pre.concat(cur.quizzes), [])
        .length + offset;
    },
    selectExercise(index) {
      if (this.isSceneFinished) {
        this.scene = SCENE.examList;
        this.$nextTick(() => {
          this.setAnchor(index);
        });
      } else {
        this.$refs.controller.exerciseIndex = index;
      }
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    handleSubmitExamBtn() {
      clearInterval(this.timer);
      this.submitExam();
      this.scene = SCENE.finished;
    },
    setAnchor(index) {
      const { code } = this.results[index];
      this.$refs.examList.setAnchor(index, {
        autoPlay: code !== 'THXZ',
      });
      this.isShowAnswerCard = false;
    },
    detail() {
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    prev() {
      this.$refs.controller.prev();
    },
    next(type) {
      if (this.currentExercise.code === 'QHLJ' && type === 'text') return;
      if ((this.currentExercise.code === 'XCTK' || this.currentExercise.code === 'TK') && type === 'text') {
        const { id } = this.currentExercise;
        const { isComplete } = utils.Array.find(this.results, { id }, 'id') || {};

        if (!isComplete) return;
      }

      if (this.$refs.controller) {
        this.$refs.controller.next(type);
      }

      this.$nextTick(() => {
        if (this.$refs.wrap) {
          this.$refs.wrap.scrollTop = 0;
        }
      });
    },
    speak() {
      this.$refs.controller.speak();
    },
    clear() {
      this.$refs.controller.clear();
    },
    handleGlobalEnter(event) {
      if (this.isShowAnswerCard) return;
      if (this.isSceneReady && event.keyCode === 13) {
        this.scene = SCENE.playing;
      }
      if (!this.isScenePlaying) return;
      if (event.keyCode === 13 && this.isExam) {
        const obj = event.target || event.srcElement; // 获取事件源
        const type = obj.type || obj.getAttribute('type');
        this.next(type);
      }
    },
    bindEnterEvent() {
      document.addEventListener('keyup', this.handleGlobalEnter);
    },
    unBindEnterEvent() {
      document.removeEventListener('keyup', this.handleGlobalEnter);
    },
    handlerFilterResult(isCheckAll) {
      if (!isCheckAll) {
        this.filterResult = this.results.filter(item => !item.isRight);
      } else {
        this.filterResult = [];
      }
    },
    openCertificate() {
      this.$emit('openCertificate');
    },
  },
  created() {
    this.retry = () => {};
  },
  mounted() {
    this.bindEnterEvent();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .bkw-dialog {
    height: 100%;
    position: relative;
    overflow: hidden;
    user-select: none;
    &.bkw-dialog__exam {
      .bkw-dialog-wrap {
        height: 100%
      }
    }
    .bkw-dialog-wrap {
      height: 100%;
      overflow-y: auto;
      .ready {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #fff;
        .description {
          font-weight: 500;
          font-size: 16px;
        }
        .el-button {
          min-width: 120px;
        }
        .button-wrapper {
          display: flex;
          justify-content: center;
        }
      }
      .rest {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .info {
          margin: 0 0 20px;
          width: 300px;
          height: 300px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
          border-radius: 50%;
          border: 1px solid $primary;
          div {
            margin-bottom: 20px;
            .active {
              font-weight: bold;
              color: $primary;
            }
          }
        }
        .el-button {
          min-width: 120px;
        }
      }
      .result {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        div {
          margin: 20px 0;
        }
        .el-button {
          margin: 0 20px;
          min-width: 120px;
        }
      }
      .time {
        position: absolute;
        top: 10px;
        right: 0;
        transform: translateX(-50%);
        font-size: 22px;
        color: $primary;
      }
      .finished {
        height: 100%;
      }
      .tip-line {
        margin-top: 20px;
      }
    }
    .exam-control {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      padding: 5px 20px;
      width: 100%;
      /deep/ .button-wrap {
        display: flex;
        .footer-button-wrapper {
          display: flex;
          button {
            margin: 0 10px 0 0;
          }
        }
      }
    }
    .answer-card {
      .detail {
        margin-top: -20px;
        padding: 0 40px 20px;
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 158px);
        overflow-y: auto;
        .item {
          width: 100%;
          padding-bottom: 5px;
          border-bottom: 1px solid #eee;
          text-align: left;
          .tag {
            margin: 20px 0 5px 10px;
            text-align: left;
          }
          .number {
            cursor: pointer;
            display: inline-block;
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin: 10px;
            font-weight: bold;
            border-radius: 50%;
            color: $primary;
            border: 1px solid $primary;
            &.filled {
              color: #fff;
              background-color: $primary;
            }
            &.danger {
              color: #fff;
              background-color: $danger;
              border: 1px solid $danger;
            }
            &.success {
              color: #333;
              background-color: #b8dfff;
              border: 1px solid #b8dfff;
            }
          }
        }
      }
      .exam-detail {
        height: calc(100% - 315px);
      }
    }
  }
</style>
